/**
 * Created by Tiger on 26/02/2022.
 */
import Types from '../../action/types';

const defaultState = {
  tableLoading: true, originalData: [], total: 0, configList: [], aliHostList: [], products: [], loadingProducts: true,
};
export default function onAction(state = defaultState, action) {
  switch (action.type) {
    case Types.REFRESH_CONFIG_LIST:
      return {
        ...defaultState,...state,
      };
    case Types.REFRESH_CONFIG_LIST_SUCCESS:
      return {
        ...state, tableLoading: false, ...action,
      };
    case Types.REFRESH_CONFIG_LIST_FAIL:
      return {
        ...defaultState,...state,  tableLoading: false,
      };
    case Types.REFRESH_ALI_HOST_LIST:
      return {
        ...state, hostLoading: true,
      };
    case Types.REFRESH_ALI_HOST_LIST_FAIL:
      return {
        ...state, hostLoading: false, aliHostList: [],
      };
    case Types.REFRESH_ALI_HOST_LIST_SUCCESS:
      return {
        ...state, hostLoading: false, aliHostList: action.hostsList,
      };
    case Types.REFRESH_PRODUCT_LIST:
      return {
        ...state,
      };
    case Types.REFRESH_PRODUCT_LIST_SUCCESS:
    case Types.REFRESH_PRODUCT_LIST_FAIL:
      return {
        ...state, ...action, loadingProducts: false,
      };
    default:
      return { ...state };
  }
}
